<template>
  <section>
    <vue-apex-charts
      class="newscolchart"
      ref="newscolumnchart"
      type="bar"
      :height="colChartHeight"
      :options="chartOptions"
      :series="series"
    />
  </section>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

const colorMap = ["#07E269", "#1951DC", "#1817E7"];
const localeFloatOpt = { minimumFractionDigits: 1, maximumFractionDigits: 1 };

export default {
  name: "NewsColumnChart",
  components: {
    VueApexCharts,
  },
  data() {
    return {
      colChartHeight: 300,
      chartOptions: {
        chart: {
          type: "bar",
          background: '#F4F4F4',
          toolbar:{
            show: false
          },
          events: {
            click: (event, chartContext, opts) => {
              var searchKeyword = this.chartCategories[opts.dataPointIndex];

              if (searchKeyword != null) {
                if (searchKeyword == 'TOTAL')
                  searchKeyword = this.baseKeyword;

                this.$parent.$parent.$parent.getNewsData(searchKeyword);
              }
            }
          }
        },
        grid:{
          show: true,
        },
        dataLabels: {
          enabled: false,
          textAnchor: 'middle',
          offsetX: 0,
          style: {
            fontSize: '10px',
            fontFamily: "NanumBarunGothicB !important",
            fontWeight: 600,
            colors: ['#222'],
          },
          formatter: function (val, opt) {
            return val.toLocaleString()
          },
          dropShadow: {
            enabled: false
          },
        },
        stroke: {
          width: 2,
          colors: ['transparent']
        },
        xaxis: {
          categories: [],
          tooltip: {
            enabled: false
          }
        },
        yaxis: {
          min: 0,
          axisTicks: {
            show: false,
          },
          axisBorder: {
            show: false,
            color: "#008FFB",
          },
          labels: {
            style: {
              colors: "#008FFB",
            },
            formatter(value) {
              let val = Math.round(value * 10) / 10;

              if (val >= 10 ** 3 && val < 10 ** 6)
                return (val / 1000).toLocaleString(undefined, localeFloatOpt) + 'K';
              else if (val >= 10 ** 6)
                return (val / 1000000).toLocaleString(undefined, localeFloatOpt) + 'M';
              else
                return (val).toLocaleString(undefined, localeFloatOpt);
            },
          },
          title: {
            text: 'Search Volume',
            style: {
              color: "#008FFB",
            },
          },
          tooltip: {
            enabled: false,
          },
        },
        tooltip: {
          style: {
            fontFamily: "NanumBarunGothic !important",
          },
          followCursor: true,
          y: {
            formatter(value){
              return value.toLocaleString();
            },
          },
        },
        legend: {
          show: true,
          position: "top",
          horizontalAlign: "right",
          offsetX: 0,
          fontSize: "12px",
          fontFamily: "NanumBarunGothic !important",
          itemMargin: {
            horizontal: 5,
            vertical: 2,
          },
          onItemClick: {
            toggleDataSeries: true
          },
          onItemHover: {
            highlightDataSeries: true
          },
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '45%',
            borderRadius: 5,
            borderRadiusApplication: 'end',
          }
        },
        noData: {
          text: '분석중...',
          align: 'center',
          verticalAlign: 'middle',
          offsetX: 0,
          offsetY: 0,
          style: {
            color: '#1817E7',
            fontSize: '20px',
            fontFamily: "NanumBarunGothicB !important"
          }
        },
        colors: colorMap,
      },
      series: [{
        name: "",
        data: []
      }],
    };
  },
  props: {
    colChartData: {
      type: Array,
      default: () => []
    },
    chartCategories: {
      type: Array,
      default: () => []
    },
    isChartInit: {
      type: Boolean,
      default: false
    },
    baseKeyword: {
      type: String,
      default: ""
    },
  },
  watch: {
    colChartData: {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (this.series.length > 0 && this.series.toString() == newVal.toString())
          return;

        this.series = newVal;
      }
    },
  },

  methods:{
  },

  created() {
  },

  mounted() {
    if (!this.isChartInit) {
      const colChartOption = {
        noData: {
          text: '분석중...',
          style: {
            color: '#1817E7',
          }
        },
      };

      this.$refs.newscolumnchart.updateOptions(colChartOption, true);

      return;
    }

    if (this.series.length > 0) { 
      const colChartOption = {
        xaxis: {
          categories: this.chartCategories,
        },
      };

      this.$refs.newscolumnchart.updateOptions(colChartOption, true);
    }
    else {
      const colChartOption = {
        noData: {
          text: '해당하는 키워드가 없습니다.',
          style: {
            color: '#FF009C',
          }
        },
      };

      this.$refs.newscolumnchart.updateOptions(colChartOption, true);
    }
  }
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/chart-apex.scss";

.newscolchart .apexcharts-canvas .apexcharts-legend-series .apexcharts-legend-text {
  color: #4e5154 !important;
  font-size: 12px !important;
  font-weight: 600 !important;
  padding-left: 0px;
}

.newscolchart .apexcharts-canvas .apexcharts-text {
  font-family: NanumBarunGothic !important;
  color: #6e6b7b !important;
  font-size: 10px !important;
  font-weight: 600 !important;
  padding-left: 0px;
}

.newscolchart .apexcharts-canvas .apexcharts-tooltip .apexcharts-tooltip-title {
  font-size: 12px !important;
  font-weight: 600;
}

.newscolchart .apexcharts-canvas .apexcharts-tooltip-text {
  font-family: NanumBarunGothic !important;
  font-weight: 400;
  font-size: 10px !important;
  filter: none;
}

</style>